
import React from 'react';
import { FadeModal } from '../../Transitions';
import EditChat from '../../../Popups/EditChat';


interface NewChatModalProps {
  show: boolean;
  onHide: () => void;
  onCreated: () => void;
}

export const NewChatModal: React.FC<NewChatModalProps> = ({ show, onHide, onCreated }) => (
  <FadeModal show={show} onHide={onHide} title="New Conversation">
    <EditChat
      onChange={() => {
        onCreated();
        onHide();
      }}
      onClose={onHide}
    />
  </FadeModal>
);

